import RoutesApp from './routes';

function App() {
  return (
    <div className="app">
      <RoutesApp />
    </div>
  );
}

export default App;
